import KpiCard from "./shared/KpiCard.jsx";

export default function KpiCards({ totalEmployees, checkedInToday, onLeaveToday, notCheckedIn }) {
  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-4">
      <KpiCard title="Total Employees"  value={totalEmployees}  note="Org size"  />
      <KpiCard title="Checked In Today" value={checkedInToday}  note="Present"   color="green" />
      <KpiCard title="On Leave"         value={onLeaveToday}    note="Today"     color="amber" />
      <KpiCard title="Not Checked In"   value={notCheckedIn}    note="Pending"   />
    </div>
  );
}
